import React, { useCallback, useRef } from 'react';
import { ReactComponent as UploadIcon } from 'assets/images/upload.svg';
import styles from './styles.module.scss';
import { DefaultButton } from 'components/Buttons/DefaultButton';

type InputProps = {
  placeholder: string;
  supportPdf?: boolean;
  onChange?: (file: File) => void;
  onClick?: () => void;
};

export const UploadImageV2 = (
  { onChange, onClick, supportPdf }: InputProps,
  ref: any
) => {
  const inputFile: any = useRef(null);

  function handleChange(e: any) {
    onChange && onChange(e.target.files[0]);
  }

  const onClickHandler = useCallback(() => {
    if (onClick) {
      onClick();
    } else {
      if ('current' in ref) {
        ref.current.click();
        ref.current.value = '';
      } else {
        inputFile.current.click();
        inputFile.current.value = '';
      }
    }
  }, [ref]);

  return (
    <div className={styles.root} onClick={onClickHandler}>
      <div className={styles.uploadArea}>
        <DefaultButton
          icon={<UploadIcon style={{ fill: '#000' }} />}
          iconPosition="right"
        >
          Upload Photo
        </DefaultButton>
        <input
          onChange={handleChange}
          ref={'current' in ref ? ref : inputFile}
          accept={`image/png, image/jpg, image/jpeg, capture, image/heic, image/heif, ${
            supportPdf ? 'application/pdf' : ''
          }`}
          type="file"
        />
      </div>
    </div>
  );
};
